import React, { useState } from 'react';
import { Modal } from 'antd';
import AuditDetail from 'vl-common/src/components/Audit/AuditDetail';
import { AuditedDetailsCategory, defaultEndDate } from 'vl-common/src/components/Audit/auditData';
import AuditDatesPicker from 'vl-common/src/components/Audit/AuditDatesPicker';
import { ModalProps } from 'antd/es/modal';
import { format, subDays } from 'date-fns';

interface AppointmentAuditProps extends ModalProps {
  show: boolean;
  selectedApptId: string | null;
  onClose: () => void;
}

const AppointmentAuditModal = ({ show, selectedApptId, onClose }: AppointmentAuditProps) => {
  const fromDate = format(subDays(new Date(), 13), 'yyyy-MM-dd');
  const [eventsStartDate, setEventsStartDate] = useState(fromDate);
  const [eventsEndDate, setEventsEndDate] = useState(defaultEndDate);
  return (
    <Modal
      open={show}
      onCancel={onClose}
      title={'Appointment Audit'}
      data-testid="view-appt-audit-trail-modal"
      width="90%"
      styles={{ body: { padding: '8px 0' } }}
      centered
      keyboard={false}
      footer={[]}
    >
      <AuditDatesPicker
        eventsStartDate={eventsStartDate}
        eventsEndDate={eventsEndDate}
        setEventsStartDate={setEventsStartDate}
        setEventsEndDate={setEventsEndDate}
      />
      <AuditDetail
        id={Number(selectedApptId)}
        category={AuditedDetailsCategory.appointments}
        start_date={eventsStartDate}
        end_date={eventsEndDate}
      />
    </Modal>
  );
};

export default AppointmentAuditModal;
